
import { defineComponent } from "vue";

export default defineComponent({
    name: 'Skeleton',
    props: {
        isCombinedMode: {
            type: Boolean,
            default: false,
        },
    },
});
